<template>
  <v-card>
    <div class="text-xs-center py-3"><h1>OUT-OF-SERVICE AREA SETTING</h1></div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      @click="formDialog = true"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <v-card-text
      v-if="keywordList.length > 0 && isLoading == false"
      style="height: 60vh"
    >
      <v-layout wrap>
        <v-flex
          xs4
          v-for="(keyword, index) in keywordList"
          :key="index"
          class="pa-1"
          ><v-card class="elevation-1"
            ><v-card-text style="display: flex; align-items: center"
              ><div>{{ keyword.blacklist_area_keyword }}</div>
              <v-spacer></v-spacer>
              <div>
                <v-btn icon small @click="toEdit(keyword)"
                  ><v-icon color="info"
                    >drive_file_rename_outline</v-icon
                  ></v-btn
                ><v-btn icon small @click="deleteKeyword(keyword)"
                  ><v-icon color="error">delete</v-icon></v-btn
                >
              </div></v-card-text
            ></v-card
          ></v-flex
        ></v-layout
      >
    </v-card-text>
    <v-card-text
      v-if="keywordList.length == 0"
      style="
        height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      No Data Available</v-card-text
    >
    <v-card-text
      v-if="isLoading == true"
      style="
        height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center;
      "
      ><div class="lds-dual-ring"></div
    ></v-card-text>
    <v-card-actions style="display: flex; justify-content: center"
      ><v-pagination
        @input="fetchData()"
        v-if="Math.ceil(totalItems / 12) > 1 && isLoading == false"
        v-model="page"
        :length="Math.ceil(totalItems / 12)"
        circle
      ></v-pagination
    ></v-card-actions>
    <formKeywordDialog
      @create="addNewKeyword($event)"
      :selectedItem="selectedItem"
      @edit="changeKeyword($event)"
      @cancel="
        formDialog = false;
        selectedIndex = -1;
      "
      :dialog="formDialog"
      :selectedIndex="selectedIndex"
    />
  </v-card>
</template>

<script>
import formKeywordDialog from "@/components/back-office/SetApp/OutOfServiceArea/formKeywordDialog.vue";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      page: 1,
      totalItems: 0,
      keywordList: [],
      isLoading: false,
      formDialog: false,
      selectedIndex: -1,
      selectedItem: {},
    };
  },
  components: {
    formKeywordDialog,
  },
  methods: {
    ...mapActions({
      fetchKeywordList: "fetchFoodSetAppBack/getBackListKeywordList",
      createKeyword: "fetchFoodSetAppBack/createBackListKeyword",
      removeKeyword: "fetchFoodSetAppBack/removeBackListKeyword",
      editKeyword: "fetchFoodSetAppBack/editBackListKeyword",
    }),
    toEdit(item, index) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.selectedIndex = index;
      this.formDialog = true;
    },
    async addNewKeyword(form) {
      let payload = {
        province: this.$route.params.province,
        keyword: form.keyword,
      };
      let result = await this.createKeyword(payload);
      if (result !== false && result.msg && result.msg === true) {
        await this.fetchData();
        this.formDialog = false;
        this.selectedIndex = -1;
      }
      form.done();
    },
    async deleteKeyword(item) {
      let payload = {
        province: this.$route.params.province,
        keyword_id: item.blacklist_area_id,
      };
      let result = await this.removeKeyword(payload);
      if (result !== false && result.msg && result.msg === true) {
        await this.fetchData();
      }
    },
    async changeKeyword(form) {
      let payload = {
        keyword: form.keyword,
        province: this.$route.params.province,
        keyword_id: this.selectedItem.blacklist_area_id,
      };
      let result = await this.editKeyword(payload);
      if (result !== false && result.msg && result.msg === true) {
        await this.fetchData();
        this.formDialog = false;
        this.selectedIndex = -1;
      }
      form.done();
    },
    async fetchData() {
      this.isLoading = true;
      let payload = {
        page_size: 12,
        page: this.page,
        province: this.$route.params.province,
      };
      let response = await this.fetchKeywordList(payload);
      if (response !== false) {
        this.totalItems = response.length;
        this.keywordList = response.data;
      }
      this.isLoading = false;
      return;
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid black;
  border-color: black transparent black transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>